import { getComponent } from "../../world/Entity";
import type { Interaction } from "../Interaction";
import type { EntityComponent } from "../../world/components";

export const lookInteraction: Interaction = {
  id: "look",
  label: "Look",
  canExecute: (ctx) => ctx.entity !== undefined || ctx.inventoryItem !== undefined,
  execute: async (ctx) => {
    if (ctx.entity) {
      const inspectable = getComponent(ctx.entity, "inspectable");
      return { success: true, message: inspectable?.description ?? "Nothing special." };
    }
    if (ctx.inventoryItem) {
      const components = (ctx.inventoryItem.metadata as { components?: readonly EntityComponent[] } | undefined)?.components;
      const inspectable = components?.find((c) => c.type === "inspectable");
      return { success: true, message: inspectable?.description ?? "Nothing special." };
    }
    return { success: true, message: "Nothing special." };
  },
};
